import OrderTotalsLoyaltyEnabled from './OrderTotalsLoyaltyEnabled';

export default OrderTotalsLoyaltyEnabled;
